import vars from '../helpers';

// let resizeTimeout = null;

const init = () => {
	const $sliders = $('.js-slider-container');

	$sliders.each((i, slider) => {
		const $slider = $(slider);
		const $prev = $slider.closest('.js-slider').find('.js-slider-button-prev');
		const $next = $slider.closest('.js-slider').find('.js-slider-button-next');
		const type = $slider.closest('.js-slider').data('type');
		const $backup = $slider.clone();

		if ($slider.hasClass('slick-initialized')) {
			return;
		}

		$slider.on('init', () => {
			$slider.closest('.js-slider').find('.js-slider-image[data-slide="1"]').removeClass('is-hidden');
		});

		$slider.slick({
			arrows: false,
			dots: false,
			// speed: vars.isMobile() ? 1000 : 2000,
			speed: 1000,
			// infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			vertical: true,
			verticalSwiping: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						swipe: type === 'left' ? false : true, // eslint-disable-line
						vertical: false,
						verticalSwiping: false,
					},
				},
			],
		});

		$slider.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
			if (vars.isMobile()) {
				return;
			}

			const $currentSlide = $(slick.$slides.get(currentSlide));
			const $currentText = $currentSlide.find('.js-slider-text');
			const $currentImages = $slider.closest('.js-slider').find(`.js-slider-image[data-slide="${+$currentSlide.find('.js-slide').data('slide')}"]`);

			const $nextSlide = $(slick.$slides.get(nextSlide));
			const $nextText = $nextSlide.find('.js-slider-text');
			const $nextImages = $slider.closest('.js-slider').find(`.js-slider-image[data-slide="${+$nextSlide.find('.js-slide').data('slide')}"]`);

			const $texts = $slider.find('.js-slider-text');

			const tl = gsap.timeline();

			vars.gsapCleaner([$currentText, $nextText]);

			tl
				.to($currentText, {
					onComplete() {
						$texts.addClass('is-hidden');
					},
					opacity: 0,
					duration: 0.25,
					clearProps: 'all',
				}, 0)
				.to($currentImages, {
					onComplete() {
						$currentImages.addClass('is-hidden');
					},
					opacity: 0,
					duration: 0.5,
					clearProps: 'all',
				}, 0)
				.from($nextText, {
					onStart() {
						$texts.removeClass('is-hidden');

						// console.log($texts, 'remove');
					},
					opacity: 0,
					duration: 0.25,
					clearProps: 'all',
				}, 0.5)
				.from($nextImages, {
					onStart() {
						$nextImages.removeClass('is-hidden');
					},
					onComplete() {
						$slider.closest('.js-slider').data('slide', nextSlide + 1).attr('data-slide', nextSlide + 1);
					},
					opacity: 0,
					duration: 0.5,
					clearProps: 'all',
				}, 0.5)
			;
		});

		// $slider.on('afterChange', (e, slick, currentSlide, nextSlide) => {

		// });

		$prev.on('click', () => {
			$slider.slick('slickPrev');
		});

		$next.on('click', () => {
			$slider.slick('slickNext');
		});

		vars.$html.on('slider-destroy', () => {
			$slider.closest('.js-slider').find('.js-slider-image:not(.is-hidden)').addClass('is-hidden');
			$slider.slick('unslick');

			vars.gsapCleaner($slider.closest('.js-slider').find('.js-slider-image'));

			$slider.closest('.js-slider').find('.js-slider-container').remove();
			$(`.js-slider[data-type="${type}"]`).append($backup);
		});

		vars.$html.on('slider-remove-slide', () => {
			const currentSlide = $slider.slick('slickCurrentSlide');
			const $currentImages = $slider.closest('.js-slider').find('.js-slider-image:not(.is-hidden)');

			$slider.slick('slickRemove', currentSlide);
			$currentImages.addClass('is-hidden');

			let j = 0;

			$slider.find('.slick-slide:not(.slick-cloned)').each((k, slide) => {
				$(slide).attr('data-slick-index', j);
				j++;
			});

			const $nextImages = $slider.closest('.js-slider').find(`.js-slider-image[data-slide="${$slider.find('.slick-current .js-slide').data('slide')}"]`);

			$nextImages.removeClass('is-hidden');
		});

		vars.$html.on('slider-update', (e, slide) => {
			$slider.slick('slickGoTo', slide);
		});
	});
};

const destroy = () => {
	vars.$html.trigger('slider-destroy');
};

const update = (slide) => {
	vars.$html.trigger('slider-update', slide);
};

// vars.$window.on('resize', () => {
// 	if (resizeTimeout) {
// 		clearTimeout(resizeTimeout);
// 	}

// 	resizeTimeout = setTimeout(() => {
// 		destroy();
// 		init();
// 	}, 500);
// });

export default {
	init,
	update,
	destroy,
};
